import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c41bd89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component menu" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "focus-box" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menu, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: menu,
        class: _normalizeClass(["menu-tab", {'active': menu.active}]),
        onClick: ($event: any) => (_ctx.moveMenu(menu, idx))
      }, [
        _createElementVNode("h3", null, _toDisplayString(menu.menu), 1),
        _hoisted_3
      ], 10, _hoisted_2))
    }), 128))
  ]))
}